import { SYLLABUS_ALL_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  selectedCourse: "",
  selectedWhereComing: "",
};

export const syllabusCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SYLLABUS_ALL_ACTIONS_TYPE.SELECT_COURSE_FOR_SYLLABUS:
      return {
        ...state,
        selectedCourse: action.payload,
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.SELECT_WHERE_COMING:
      return {
        ...state,
        selectedWhereComing: action.payload,
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.CLEAR_COURSE:
      return {
        ...state,
        selectedCourse: "",
      };
    case SYLLABUS_ALL_ACTIONS_TYPE.CLEAR_WHERE_COMING:
      return {
        ...state,
        selectedWhereComing: "",
      };
    default:
      return state;
  }
};
